import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-cargo',
  templateUrl: './add-cargo.component.html',
  styleUrls: ['./add-cargo.component.css']
})
export class AddCargoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
